import sendLocalRequest from "./sendLocalRequest";
export const verifyToken = (token) => {
    const data = {
        "token": token
    }
    return sendLocalRequest("verify_token", "POST", null,  data);
}
